import localforage from 'localforage';
import { UserNote } from '@/types/UserNote';
import { createBrowserClientSupa } from './supabase/createBrowserClient';
import { UserNoteStore } from './useZStore';

export const LOCAL_USER_NOTES_KEY = 'userNotes';

const getUserNotesFromSupa = async () => {
  const supabase = createBrowserClientSupa();
  // TO-DO: user_id is not much used, find a way to remove it
  const { data, error } = await supabase
    .from('user_notes')
    .select(`*, examples (*)`);

  if (error) {
    return { error: true, data: [] };
  }
  // This is all because supabase does not allow easy filtering of
  // joined tables
  // TO-DO: Ask a question on supabase forums
  const nonDraft = data?.filter((note) => !note.examples?.draft);
  const trimmed = nonDraft?.map((note) => {
    const { examples, ...rest } = note;
    return rest;
  });
  return { error: false, data: trimmed as UserNote[] };
};

export const getUserNotesFromLocal = async () => {
  // TO-DO: use zod to validate?
  try {
    const userNotes = ((await localforage.getItem(LOCAL_USER_NOTES_KEY)) ||
      {}) as UserNoteStore;
    const userNotesArray = Object.values(userNotes);
    return { error: false, data: userNotesArray };
  } catch (error) {
    console.log('Error getting user notes from local:', error);
    return { error: true, data: [] };
  }
};

// TO-DO: Solve this typing issue
type Method = typeof getUserNotesFromLocal;

// TO-DO: This hould be  function bound top initiate
// If we do thatm then we can retienve them as a dictionary and not an array
// in getUserNotesFromLocal
export const getUserNotes = async (userId?: string | null) => {
  const method: Method = userId ? getUserNotesFromSupa : getUserNotesFromLocal;
  const { data, error } = await method();
  return { data, error };
};
